export default function () {
  return {
    message: '',
    errors: null,
    loading: false,
  }
}
